import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";

const store = {
  namespaced: true,
  state: {
    enroll: null
  },
  getters: {
    enroll(state) {
      return state.enroll;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelasenrol${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPropinsi({}, _) {
      return axios
        .get(`${M_API}/master?master=propinsi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKota({}, k_propinsi) {
      return axios
        .get(`${M_API}/master?master=kota&&k_propinsi=${k_propinsi}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKecamatan({}, { k_propinsi, k_kota }) {
      return axios
        .get(`${M_API}/master?master=kecamatan&&k_propinsi=${k_propinsi}&&k_kota=${k_kota}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    form(_, { instansi_id, diklat_id, kelas_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/enrol`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    setUtama(_, { instansi_id, diklat_id, kelas_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/setutama`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    formGuru(_, { instansi_id, diklat_id, kelas_id, modul_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${modul_id}/enrolkelasmodul`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    settingJadwal(_, { instansi_id, diklat_id, kelas_id, modul_id, obj }) {
      return axios
        .put(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${modul_id}`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    unenrolled(_, { instansi_id, diklat_id, kelas_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/unenrol`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    unenrolledPengampu(_, { instansi_id, diklat_id, kelas_id, modul_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${modul_id}/unenrolkelasmodul`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    detail(_, { instansi_id, diklat_id, enroll_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${enroll_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${API}/enroll/${item.user_id}`).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
